import { IotsVolumeByStatusDonutChart } from '@frontend/chart/components';
import { FormattedMessage, useIntl } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { getIotStatusColor, getIotStatusDisplayLabel } from '../iot-status-display';
import { useHardwareIotsVolumeByStatusDonutChart } from './use-hardware-iots-volume-by-status-donut-chart';

export interface HardwareIotsVolumeByStatusDonutChartProps {
    accountId: string;
}

export const HardwareIotsVolumeByStatusDonutChart = (props: HardwareIotsVolumeByStatusDonutChartProps) => {
    const intl = useIntl();
    const { data, isLoading, offlineCount } = useHardwareIotsVolumeByStatusDonutChart(props);

    return (
        <StatisticsCard
            chartKey={IotsVolumeByStatusDonutChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.hardware-iots-volume-by-status-donut-chart.title'
                    description='Title of the hardware dashboard chart showing IoT counts grouped by operational status'
                    defaultMessage='Fleet health'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.hardware.hardware-iots-volume-by-status-donut-chart.offline-subtitle'
                    description='Subtitle on the hardware fleet health donut showing how many IoTs are currently offline'
                    defaultMessage='{count, plural, =0 {No IoTs offline} one {# IoT offline} other {# IoTs offline}}'
                    values={{ count: offlineCount }}
                />
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <IotsVolumeByStatusDonutChart
                        data={data}
                        minHeight={80}
                        chartOptions={{
                            colors: data.series.map((series) => getIotStatusColor(series.name)),
                            labels: data.series.map((series) => getIotStatusDisplayLabel(series.name ?? '', intl))
                        }}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
